import './style.css';
import '../styles/style.css';

import { View } from '@zinc/ui';
import { computed } from 'mobx';
import { observer, Provider } from 'mobx-react';
import type React from 'react';
import { Editor } from 'tm2-draft-js';
import DraftBase from '../base/draft-base';
import ViewSignature from '../form/signature';
import type FormStore from '../stores/form-store';

export interface IProps {
  className?: string;
  store: FormStore;
  styleMap?: Record<string, React.CSSProperties>;
  usePrintStyle?: boolean;
  signature?: string;
  completedAt?: string;
  completedBy?: string;
}

@observer
class Review extends DraftBase<IProps> {
  static defaultProps: Partial<IProps> = {
    styleMap: {}
  };

  constructor(props: IProps) {
    super(props);

    this.styleMap = Object.assign(
      this.styleMap,
      {
        SUMMARY: { display: 'inline' },
        HIGHLIGHT: { display: 'inline' }
      },
      this.props.styleMap
    );
  }

  @computed
  get className() {
    const { usePrintStyle = true, className } = this.props;
    return ['review'].addIf(usePrintStyle, 'live').addNotEmpty(className).toClassNames();
  }

  @computed
  get signatureApproval() {
    const { store, signature } = this.props;
    return signature ?? store.signature;
  }

  render() {
    let { store, signature, completedAt, completedBy } = this.props;
    let { editor, blockRenderMap } = store;

    return (
      <Provider draftStore={store}>
        <div className={this.className}>
          <View width="100%">
            <Editor
              style={{ minHeight: 400 }}
              blockRendererFn={this.blockRendererFn}
              blockRenderMap={blockRenderMap}
              blockStyleFn={this.blockStyleFn}
              customStyleMap={this.styleMap}
              editorState={editor}
              readOnly={true}
            />
            <div className="flex place-content-end w-full">
              {this.signatureApproval && (
                <ViewSignature
                  signature={this.signatureApproval}
                  signedAt={completedAt}
                  signedBy={completedBy}
                />
              )}
            </div>
          </View>
        </div>
      </Provider>
    );
  }
}

export const { defaultProps } = Review;
export default Review;
